"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["cancel"] = "cancel";
  TranslationKey["close"] = "close";
  TranslationKey["email"] = "email";
  TranslationKey["loadMore"] = "loadMore";
  TranslationKey["olapic2Report"] = "olapic2Report";
  TranslationKey["olapic2ReportFailed"] = "olapic2ReportFailed";
  TranslationKey["olapic2ReportPhotoAreYouSure"] = "olapic2ReportPhotoAreYouSure";
  TranslationKey["olapic2ReportPhotoExplanation"] = "olapic2ReportPhotoExplanation";
  TranslationKey["olapic2ReportSuccess"] = "olapic2ReportSuccess";
  TranslationKey["olapic2ShareWith"] = "olapic2ShareWith";
  TranslationKey["oriflameOnMe"] = "oriflameOnMe";
  TranslationKey["reason"] = "reason";
  TranslationKey["reportPhoto"] = "reportPhoto";
  TranslationKey["sharePost"] = "sharePost";
  TranslationKey["shopThisLook"] = "shopThisLook";
  TranslationKey["viewAll"] = "viewAll";
  return TranslationKey;
}({});
